module.exports = "/_next/static/images/Frame-453d98e2f5bb88d6ba012fdd1ad3421f.webp";